import '../scss/main.scss'
import { initZoomScale } from './modules/zoom-scale'
import { initHeader } from './modules/header'
import { initFloatingBanner } from './modules/floating-banner'
import { initFvSlider } from './modules/fv-slider'
import { initVideoSlider } from './modules/video-slider'
import { initSearchRestaurant } from './modules/search-restaurant'
import { initFeatureFavorite } from './modules/feature-favorite'
import { initFadeInUp } from './modules/fade-in-up'
import { initFeatureVideo } from './modules/feature-video'
import { initHomeSearch } from './modules/home-search'
import { initBackToTop } from './modules/back-to-top'

document.addEventListener('DOMContentLoaded', () => {
  initZoomScale()
  initHeader()
  initFloatingBanner()
  initFvSlider()
  initVideoSlider()
  initSearchRestaurant()
  initHomeSearch()
  initFeatureFavorite()
  initFadeInUp()
  initFeatureVideo()
  initBackToTop()
})
